<template>
    <Header></Header>
    <Left></Left>
    <section class="container">
        <div>
            <div class="area_title">
                <p>녹취록</p>
            </div>
            <div class="area_body">
                <div class="area_section">
                    <div class="area_search">
                        <div>
                            <label>작성일</label>
                            <div>
                                <div class="datepicker"><input type="date" id="startDate" v-model="state.startDate" @change="changeStartDate" /></div>
                                <span>~</span>
                                <div class="datepicker"><input type="date" id="endDate" v-model="state.endDate" @change="changeEndDate" /></div>
                                <button
                                    type="button"
                                    @click="
                                        setDateToToday();
                                        fnGetList(1);
                                    "
                                >
                                    오늘날짜
                                </button>
                            </div>
                        </div>
                        <div>
                            <label>검색조건</label>
                            <div>
                                <div class="select-wrap">
                                    <select name="searchType" v-model="state.searchType">
                                        <option value="">선택해주세요.</option>
                                        <option v-for="item in searchCondition" :value="item.key">{{ item.name }}</option>
                                    </select>
                                </div>

                                <input
                                    type="text"
                                    name="searchText"
                                    v-model="state.searchText"
                                    placeholder="검색어를 입력해주세요."
                                    v-on:keyup.enter="fnGetList(1)"
                                />
                            </div>
                        </div>

                        <div class="area_button">
                            <button
                                type="button"
                                @click="
                                    reset();
                                    fnGetList(1);
                                "
                            >
                                초기화
                            </button>
                            <button type="button" @click="fnGetList(1)">검색</button>
                        </div>
                    </div>
                </div>

                <div class="area_section">
                    <div class="area_table">
                        <div class="area_table_head">
                            <div class="select-wrap">
                                <select name="orderType" v-model="state.order" @change="fnGetList(1)">
                                    <option value="0">최근순</option>
                                    <option value="1">과거순</option>
                                </select>
                            </div>

                            <div class="total_length">
                                {{ $t("notice.total") }} : {{ CommonUtils.numberFormat(pageState.length) }} {{ $t("notice.count") }}
                            </div>
                        </div>
                        <div class="area_table_body">
                            <DataGrid
                                :list="pageState.list"
                                :columns="pageState.fields"
                                :totalLength="pageState.length"
                                :perPage="pageState.perPage"
                                :cntPage="pageState.cntPage"
                                :current-page="pageState.currentPage"
                                :isLoading="pageState.isLoading"
                                @onRowClick="fnRowClick"
                                @onPaging="fnGetList"
                                @onNextPage="fnGoPage"
                                @onPrevPage="fnGoPage"
                                @onFirstPage="fnGoPage"
                                @onLastPage="fnGoPage"
                            ></DataGrid>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <Spinner :is-full-page="true" v-if="state.isLoading"></Spinner>
    <ModalDefault
        v-if="state.isShowModal"
        :type="state.modalTab"
        :title="state.modalTitle"
        :content="state.modalContent"
        @close="state.isShowModal = false"
    ></ModalDefault>

    <FindClient v-if="state.isShowFindClient" @close="state.isShowFindClient = false" @callback="mappingClient"></FindClient>
</template>
<script lang="ts" config>
    import {
        userStore,
        globalStore,
        DataGrid,
        reactive,
        watch,
        apiService,
        onMounted,
        router,
        Header,
        Left,
        ModalDefault,
        FindClientForRecord,
        types,
        getMessageByCode,
        PageBtn,
        CommonUtils,
        CommonOptions,
        useRoute,
        Spinner,
    } from "@/BaseComponent";

    export default {
        props: {},
        components: { Header, Left, ModalDefault, PageBtn, DataGrid, Spinner, FindClient: FindClientForRecord },
        setup() {
            const global = globalStore();
            const user = userStore();
            const route = useRoute();

            const dayAgo = new Date();

            const today = new Date();
            dayAgo.setDate(today.getDate() - 90);

            const state = reactive({
                startDate: "" as string,
                endDate: "" as string,
                searchType: "" as string,
                searchText: "" as string,
                dept: 0 as number,
                order: 0 as number,

                isShowModal: false as boolean,
                modalTab: -1 as number,
                modalTitle: "alert" as string,
                modalContent: "" as string,
                isLoading: false,

                isShowFindClient: false as boolean,
                idx: 0 as number,
            });

            const searchCondition = [
                { key: "searchUniqueNumber", name: "고유번호" },
                { key: "searchNumber", name: "연번" },
                { key: "searchName", name: "이름" },
            ];

            const stateList = [
                { key: 0, name: "데이터 없음" },
                { key: 1, name: "진행" },
                { key: 2, name: "종결" },
                { key: 3, name: "보류" },
                { key: 4, name: "비해당" },
            ];

            const pageState = reactive({
                perPage: 10,
                cntPage: 5,
                currentPage: 1,
                list: [] as any,
                length: 0 as number,
                isLoading: false,
                fields: [
                    { key: "", label: "No.", class: "text-center" },
                    { key: "number", label: "고유번호", class: "text-center" },
                    {
                        key: "clIdx",
                        label: "내담자",
                        class: "text-center",
                        clickable: true,
                        render: (row: any) => {
                            if (row.clIdx) {
                                return row.client.number;
                            } else {
                                return "<span>내담자 찾기</span>";
                            }
                        },
                    },
                    {
                        key: "downRecord",
                        label: "녹취록 다운",
                        class: "text-center",
                        clickable: true,
                        render: (row: any) => {
                            return "<img src = 'img/download.png' style = 'width:24px; height:auto;cursor:pointer'>";
                        },
                    },

                    { key: "summaryText", label: "요약", class: "text-left", clickable: true },
                    {
                        key: "createDate",
                        label: "작성일",
                        class: "text-center",
                        render: (row: any) => {
                            return CommonUtils.dateFormat(row.createDate, ".", true);
                        },
                    },
                ],
            });

            onMounted(() => {
                state.startDate = dayAgo.toLocaleDateString("sv-SE");
                state.endDate = today.toLocaleDateString("sv-SE");
                fnGetList(1);
            });

            const reset = () => {
                state.startDate = "";
                state.endDate = "";
                state.searchType = "";
                state.searchText = "";
                state.dept = 0;
                state.order = 0;
            };

            const fnGetList = async (page: number) => {
                pageState.currentPage = page;
                pageState.isLoading = true;
                const param: types.ReqParam = {
                    page: page,
                    size: pageState.perPage,
                    searchType: state.searchType,
                    searchText: state.searchText,
                    order: state.order,
                    startDate: state.startDate,
                    endDate: state.endDate,
                };
                let res: types.ResPaging = await apiService.clientRecord.list(param);

                if (res.returnCode === 0 && res.list) {
                    pageState.list = res.list.data;
                    pageState.length = res.list.recordsTotal;
                } else {
                    console.error(res.description);
                }
                pageState.isLoading = false;
            };

            const fnRowClick = (row: any, col: any) => {
                if (col.key === "downRecord") {
                    downloadFile(row.textFilePath, "녹취록.txt");
                } else if (col.key === "summaryText") {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = row.summaryText.replaceAll("\n", "</br>");
                    state.isShowModal = true;
                } else if (col.key === "clIdx") {
                    if (row.clIdx) {
                        router.push({ name: "counselListForClient", params: { id: row.clIdx } });
                    } else {
                        state.idx = row.idx;
                        state.isShowFindClient = true;
                    }
                }
            };

            const fnGoPage = (page: number) => {
                pageState.currentPage = page;
            };

            const setDateToToday = () => {
                state.startDate = dayAgo.toLocaleDateString("sv-SE");
                state.endDate = today.toLocaleDateString("sv-SE");
            };

            const changeStartDate = () => {
                if (!CommonUtils.checkDateRange(state.startDate, state.endDate)) {
                    state.endDate = state.startDate;
                }
            };
            const changeEndDate = () => {
                if (!CommonUtils.checkDateRange(state.startDate, state.endDate)) {
                    state.endDate = state.startDate;
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "작성일 범위가 잘못 선택되었습니다.";
                    state.isShowModal = true;
                }
            };

            const downloadFile = async (fileUrl: string, fileName: string) => {
                const res = await fetch(fileUrl);
                const blob = await res.blob();
                const link = document.createElement("a");
                link.href = URL.createObjectURL(blob);
                link.download = fileName;
                link.click();
                URL.revokeObjectURL(link.href);
            };

            const mappingClient = async (item: types.group.GroupMemberVOForApi) => {
                const res = await apiService.clientRecord.modify(state.idx, item.clIdx);

                if (res.returnCode === 0) {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "처리 완료했습니다.";
                    state.isShowModal = true;
                    state.idx = 0;
                    fnGetList(pageState.currentPage);
                } else {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
                state.isShowFindClient = false;
            };

            return {
                state,
                pageState,
                router,
                reset,
                fnRowClick,
                fnGoPage,
                fnGetList,
                CommonUtils,
                setDateToToday,
                searchCondition,
                stateList,
                CommonOptions,
                downloadFile,
                window,
                changeStartDate,
                changeEndDate,
                mappingClient,
            };
        },
    };
</script>
<style scoped>
    .sch_list label:last-child {
        border-right: white;
    }

    tr td span {
        background-color: blue;
        color: white;
        padding: 5px 10px;
        border-radius: 5px;
    }
</style>
